import { isPopulatedArray } from "../../../../../../components/helpers";
import { ToggleNotesCell } from "../../../../../../components/table";
import { ApplicationReview } from "../../../_models";
import { useApplicationReviewTableState } from "./_store";
import { FC } from "react";

type Props = {
  row: ApplicationReview & {showNotes: boolean}  
}

export const ApplicationReviewNotesCell: FC<Props> = ({row}) => {    

  const { id, showNotes, notes } = row;
  
  const toggleNotes = useApplicationReviewTableState(state => state.toggleNotes);  

  return (
    <ToggleNotesCell id={id} show={showNotes} hasNotes={(notes && isPopulatedArray(notes))} toggleNotes={toggleNotes} />
  )
  
}
